module.exports = __webpack_public_path__ + "static/img/diyiimg2.f9ab302.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/diyiimg2.png
// module id = 6c5Y
// module chunks = 5